<template>
    <div class="daily-challenge-item active" v-if="challenge.status == 0">
        <div class="daily-challenge-item-body">
            <div>
                {{ challenge.key_open }} <i class="lisa-icon-lock-1"></i>
            </div>
            <div>
                <i class="lisa-icon-box-1"></i>
            </div>
            <div class="mt-8">
                <button class="btn btn-main btn-main-sm" disabled>{{ $t('open') }}</button>
            </div>
        </div>
    </div>
    <div class="daily-challenge-item active" v-else-if="challenge.status == 1">
        <div class="daily-challenge-item-body">
            <div>
                {{ challenge.key_open }} <i class="lisa-icon-lock-1"></i>
            </div>
            <div>
                <i class="lisa-icon-box-1"></i>
            </div>
            <div class="mt-8">
                <button class="btn btn-main btn-main-sm" @click="claim">{{ $t('open') }}</button>
            </div>
        </div>
    </div>
    <div class="daily-challenge-item" v-else-if="challenge.status == 2 || challenge.status == 3">
        <div class="daily-challenge-item-body">
            <div>
                {{ challenge.key_open }} <i class="lisa-icon-lock-1"></i>
            </div>
            <div>
                <img :src="$store.state.treasure_icon_url" class="treasure-icon" alt="Treasure Icon" />
            </div>
        </div>
    </div>
    <div class="daily-challenge-item" v-else-if="challenge.status == 4">
        <div class="daily-challenge-item-body">
            <div>
                {{ challenge.key_open }} <i class="lisa-icon-lock-1"></i>
            </div>
            <div>
                <i class="lisa-icon-box-1"></i>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { claimChestDailyChallenge } from "../../models/reward";
import { soundClick, soundGetReward, soundClaimKey } from '../../utils/utils';
import AppIcon from '@/components/common/AppIcon.vue';

export default {
    name: "DailyChallengeItem",
    components: { AppIcon },
    props: ['challenge'],

    data() {
        return {};
    },

    computed: {
        ...mapGetters([
            'user_info'
        ], () => {
            if (this.user_info) {
                return this.user_info
            }

            return {
                gem: 0
            }
        })
    },

    methods: {
        claim() {
            const that = this;

            that.getSoundClick();

            claimChestDailyChallenge({
                id: that.challenge.id,
                //is_raw: true
            }).then((response) => {

                if (response.data.code != 0) {
                    return;
                }

                const new_gem = response.data.results.update_gem || 0;
                const new_key_collect = response.data.results.key_collect || 0;
                const new_challenges = response.data.results.challenge || [];
                const gem_reward = response.data.results.gem_reward || [];

                that.user_info.dailychallenge_noti = response.data.results.dailychallenge_noti || 0;

                //const gem = new_gem - that.user_info.gem;

                that.user_info.gem = new_gem;

                this.$emit('updateNewChallenge', new_challenges, new_key_collect)

                const gem_txt = gem_reward > 0 ? '+' + gem_reward : gem_reward;

                $('#congratulation_gem').text(gem_txt);

                // that.getSoundGetReward();
                that.getSoundClaimKey();

                $('#getRewardedModal').modal("show");
            }).catch(({ response }) => {
                console.error(response);
            });
        },

        getSoundClick() {
            soundClick();
        },

        getSoundGetReward() {
            soundGetReward();
        },

        getSoundClaimKey() {
            soundClaimKey();
        },
    }
}
</script>

<style scoped>
.treasure-icon {
    background-position: -430px -3px;
    width: 82px;
    height: 66px;
    line-height: 66px;
}
</style>
